import {useMapContext} from '@/components/MindMap/index.mjs'
import openWindow from '@/script/openWindow.mjs'

export default props => {
    const map = useMapContext()
    const {mapTypeCode} = map.data

    if ('_BD_MAP' !== mapTypeCode) {
        return null
    }

    const onClick = () => {
        const {prjId, sVer} = map.data
        const {bdName, pkid} = map.root.data

        openWindow(
            '/Ai',

            {
                bizMap: {dpId: pkid},
                prjId,
                scene: 'GENERATE_UC',
                sVer,
                title: `程序模块: ${bdName}`,
            }
        )
    }

    return {
        label: '集成用例',
        onClick,
        ...props,
    }
}
